import { useAuth } from "@elit-hair/elit-tools";
import { useMemo } from "react";

import { useDashboardRole } from "@/pages/home/components/role-dashboard/hooks/use-dashboard-role";
import type { Team } from "@/types/team.types";
import { getAccessibleTeams } from "@/utils/team.utils";

/**
 * Teams the current user can access. In role preview, uses the selected team IDs
 * from the testing panel when set; otherwise falls back to permission-based access.
 */
export function useAccessibleTeams(allTeams: Team[] = []): Team[] {
    const { userData } = useAuth();
    const { permissionCodes, teamIds, isPreview } = useDashboardRole();

    return useMemo(() => {
        if (isPreview && teamIds.length > 0) {
            const allowedIds = new Set(teamIds);
            return allTeams.filter((team) => allowedIds.has(team.id));
        }

        return getAccessibleTeams(allTeams, permissionCodes, userData?.id);
    }, [allTeams, permissionCodes, teamIds, isPreview, userData?.id]);
}
